/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/happy_pot_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M12.125 17c2 2 3 1 3 3s0 2-1 3v1h4v-1c-1-1-1-1-1-3s1-1 3-3c3-3-2-6 0-9h-8c2 3-3 6 0 9zM11.125 7h10l1-2h-12zM12.125 25h8v1h-8z"/><path pid="1" d="M13.844 9l-1.49 5.96c-1.294-.12-3.394-.538-4.522-1.667-1.046-1.046-1.04-3.047-.874-4.293h6.886m1.281-1h-9s-1 4 1 6 6 2 6 2l2-8zM25.031 9c.155 1.106.252 3.17-.911 4.274-1.3 1.232-3.665 1.585-4.876 1.686L17.673 9H25.031m.83-1h-9.486l2.109 8s4.215 0 6.324-2c2.107-2 1.053-6 1.053-6zM15 32H0V17h1v14h14zM32 32H17v-1h14V17h1z"/><path pid="2" d="M32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
